// extracted by mini-css-extract-plugin
export var container = "ThemeSwitcherTopBar-module--container--73d0b";
export var label = "ThemeSwitcherTopBar-module--label--8d01c";